module.exports = __webpack_public_path__ + "img/arya-purple.0472920e.png";